<article
  class="dashboard-grid-item"
  cdkDrag
  [cdkDragDisabled]="!editMode"
  (cdkDragEnded)="onDragEnded($event)"
  [class.dashboard-grid-item--editing]="editMode"
>
  @if (editMode) {
    <div class="dashboard-grid-item__controls" aria-label="Widget layout controls">
      <button type="button" class="btn btn-icon btn-sm" cdkDragHandle title="Move widget" aria-label="Move widget">
        <svg viewBox="0 0 24 24" class="icon" aria-hidden="true"><path d="M12 3v18M3 12h18M8 7l4-4 4 4M8 17l4 4 4-4M7 8l-4 4 4 4M17 8l4 4-4 4" /></svg>
      </button>
      <button
        type="button"
        class="btn btn-icon btn-sm"
        title="Reduce width"
        aria-label="Reduce widget width"
        [disabled]="placement.width <= limits.minWidth"
        (click)="resize(-1, 0)"
      >−W</button>
      <button
        type="button"
        class="btn btn-icon btn-sm"
        title="Increase width"
        aria-label="Increase widget width"
        [disabled]="placement.width >= limits.maxWidth"
        (click)="resize(1, 0)"
      >+W</button>
      <button
        type="button"
        class="btn btn-icon btn-sm"
        title="Reduce height"
        aria-label="Reduce widget height"
        [disabled]="placement.height <= limits.minHeight"
        (click)="resize(0, -1)"
      >−H</button>
      <button
        type="button"
        class="btn btn-icon btn-sm"
        title="Increase height"
        aria-label="Increase widget height"
        [disabled]="placement.height >= limits.maxHeight"
        (click)="resize(0, 1)"
      >+H</button>
      <button type="button" class="btn btn-icon btn-sm btn-outline-danger" title="Remove widget" aria-label="Remove widget" (click)="remove.emit()">×</button>
    </div>
  }
  <div class="dashboard-grid-item__content">
    <ng-content></ng-content>
  </div>
</article>
